import ApiService, { UsersService } from "@/common/api.service";
import {
  CHECK_RESET_TOKEN,
  FETCH_USER,
  FETCH_USER_BY_ID,
  FETCH_USER_COUNT,
  FETCH_USERS,
  USER_DELETE,
  USER_EDIT,
  USER_CREATE,
  USER_RESET_PASSWORD,
  USER_UPDATE_PASSWORD
} from "./actions.type";
import { SET_USER, SET_USERS, SET_USERLIST, SET_ERROR } from "./mutations.type";
import { displayNotification } from "@/common/notification";

const state = {
  user: {},
  userList: []
};

const getters = {
  user(state) {
    return state.user;
  },
  userList(state) {
    return state.userList;
  }
};

const actions = {
  [CHECK_RESET_TOKEN](context, { resetToken, user }) {
    return UsersService.get('users/reset/' + resetToken, user)
      .then(res => {
        return true;
      })
      .catch(() => {
        displayNotification("Token expired, please reset your password again", "warning");
        return false;
      });
  },
  [FETCH_USER](context) {
    return ApiService.get("user")
      .then(({ data }) => {
        context.commit(SET_USER, data.user);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [FETCH_USER_BY_ID](context, userId ) {
    return ApiService.get("user/" + userId)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [FETCH_USER_COUNT](context) {
    return UsersService.get("usercount")
      .then(({ data }) => {
        context.commit(SET_USERS, data);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [FETCH_USERS](context) {
    return ApiService.get("users")
      .then(({ data }) => {
        context.commit(SET_USERLIST, data);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [USER_DELETE](context, userId) {
    return UsersService.delete(userId);
  },
  [USER_EDIT](context, user) {
    return UsersService.update(user);
  },
  [USER_CREATE](context, user) {
    return UsersService.create(user);
  },
  [USER_RESET_PASSWORD](context, user) {
    return UsersService.post('users/reset', user)
      .then(res => {
        displayNotification(res.data.message, "success");      
      })
      .catch(res => {
        displayNotification(res.response.data.errors.error, "warning");
      });
  },
  [USER_UPDATE_PASSWORD](context, { resetToken, user }) {
    return UsersService.post('users/reset/' + resetToken, user)
      .then(res => {
        displayNotification(res.data.message, "success");
        return true;
      })
      .catch(({ response }) => {
        displayNotification(response.data.errors.error, "warning");
        return false;
      });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_USER](state, user) {
    state.user = user;
    state.errors = {};
  },
  [SET_USERS](state, users) {
    state.users = users;
    state.errors = {};
  },
  [SET_USERLIST](state, users) {
    state.userList = users;
    state.errors = {};
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
